import './QuestionPane.css';

function QuestionPane({ question, answer, onAnswer }) {
  const {
    number,
    question: text,
    answer_options,
    certainty_options,
    lead_in_info_text,
    info_text,
  } = question;
  const selectedAnswer = answer?.answer || '';
  const selectedCertainty = answer?.certainty || '';

  const needsCertainty = certainty_options && certainty_options.length > 0;
  const isComplete = selectedAnswer && (!needsCertainty || selectedCertainty);
  const hasInfoContent = !!(lead_in_info_text || info_text);

  const questionContent = (
    <>
      <span className="question-number">Question {number}</span>
      <h3 className="question-text">{text}</h3>

      <fieldset className="question-options">
        <legend className="question-legend">Select your answer</legend>
        {answer_options &&
          answer_options.map((opt) => (
            <label key={opt} className="question-option">
              <input
                type="radio"
                name={`answer-${number}`}
                value={opt}
                checked={selectedAnswer === opt}
                onChange={() =>
                  onAnswer(number, { ...answer, answer: opt })
                }
              />
              <span>{opt}</span>
            </label>
          ))}
      </fieldset>

      {needsCertainty && (
        <fieldset className="question-options certainty-options">
          <legend className="question-legend">Level of Certainty</legend>
          {certainty_options.map((opt) => (
            <label key={opt} className="question-option">
              <input
                type="radio"
                name={`certainty-${number}`}
                value={opt}
                checked={selectedCertainty === opt}
                onChange={() =>
                  onAnswer(number, { ...answer, certainty: opt })
                }
              />
              <span>{opt}</span>
            </label>
          ))}
        </fieldset>
      )}

      {/* Expose completeness so parent can disable Next */}
      <input type="hidden" data-complete={isComplete ? 'true' : 'false'} />
    </>
  );

  if (!hasInfoContent) {
    return <div className="question-pane">{questionContent}</div>;
  }

  return (
    <div className="question-pane question-pane--two-col">
      <div className="question-left">{questionContent}</div>
      <div className="question-right">
        {lead_in_info_text && (
          <div className="info-section">
            <h4 className="info-section-header">% of Organizations Have It</h4>
            <p className="info-section-body">{lead_in_info_text}</p>
          </div>
        )}
        {info_text && (
          <div className="info-section">
            <h4 className="info-section-header">Is it in the Condition it Needs to Be In?</h4>
            <p className="info-section-body">{info_text}</p>
          </div>
        )}
      </div>
    </div>
  );
}

QuestionPane.isComplete = (question, answer) => {
  if (!answer?.answer) return false;
  const needsCertainty =
    question.certainty_options && question.certainty_options.length > 0;
  if (needsCertainty && !answer.certainty) return false;
  return true;
};

export default QuestionPane;
